import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class CollectionService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getCollection(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getCollectionItem(collectionId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/' + collectionId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageCollection(collection, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/collection/' + id, collection)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/collection/', collection)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getProperties(scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/property/properties/all')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getModelsSuppliers(supplierId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/models/supplier/' + supplierId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getProductOptions(scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/models/products/option')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public softDeleteCollection(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/collection/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getCollectionReplace(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/?' + gridData.toString())
      .pipe(map(rsp => rsp['data']), catchError(res => this.helper.catchError(res)));
  }

  public readdCollection(id) {
    return this.http.put(environment.apiUrl + '/backoffice/collection/' + id + '/reAdd', {id: id})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricCollectionWithFabrics(scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/fabriccollection/fabrics/')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getFabricCollectionWithCollection(collectionId, modelId, productId, scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/' + collectionId + '/model/' + modelId + '/product/' + productId + '/fabrics')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/collection/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setParentPosition(modelId, position) {
    return this.http.put(environment.apiUrl + '/backoffice/collection/model/' + modelId + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getCollections(gridData = new HttpParams(), scope = 'dealer-system') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/collection/?onhold=allow&' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
